var blockquote_default = {
  "fontElementMap": "ZYUuj",
  "quote": "VKix0"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
